module.exports = __webpack_public_path__ + "media/fonts/Oricons-6410b1c1492ffb4f7b787b5969253ee2.woff2";